import React, { useEffect, useState } from 'react';
import { useReactFlow } from '@xyflow/react';

const PropertyPanel = ({ selectedNode }) => {
    const { setNodes } = useReactFlow();
    const [label, setLabel] = useState('');
    const [nodeData, setNodeData] = useState({});

    useEffect(() => {
        if (selectedNode) {
            setLabel(selectedNode.data.label);
            setNodeData(selectedNode.data);
        }
    }, [selectedNode]);

    const onLabelChange = (evt) => {
        const newLabel = evt.target.value;
        setLabel(newLabel);

        setNodes((nds) =>
            nds.map((node) => {
                if (node.id === selectedNode.id) {
                    // it's important that you create a new object here
                    // in order to notify react flow about the change
                    node.data = {
                        ...node.data,
                        label: newLabel,
                    };
                }

                return node;
            })
        );
    };

    const onDataChange = (key, value) => {
        setNodeData(prev => ({ ...prev, [key]: value }));

        setNodes((nds) =>
            nds.map((node) => {
                if (node.id === selectedNode.id) {
                    node.data = {
                        ...node.data,
                        [key]: value,
                    };
                }
                return node;
            })
        );
    };

    if (!selectedNode) {
        return (
            <aside className="automation-property-panel">
                <div className="panel-empty">
                    <p>Select a node to edit properties.</p>
                </div>
            </aside>
        );
    }

    return (
        <aside className="automation-property-panel">
            <div className="panel-header">
                <h2 className="panel-title">Properties</h2>
                <p className="panel-subtitle">ID: {selectedNode.id}</p>
                <p className="panel-subtitle">Type: {selectedNode.type}</p>
            </div>

            <div className="panel-content">
                <div className="form-group" style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Label</label>
                    <input
                        type="text"
                        value={label}
                        onChange={onLabelChange}
                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                    />
                </div>

                {/* Dynamic fields based on type */}
                {(selectedNode.type === 'whatsapp' || selectedNode.data.label.toLowerCase().includes('whatsapp')) && (
                    <div className="form-group" style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Template ID</label>
                        <input
                            type="text"
                            value={nodeData.template_id || ''}
                            onChange={(e) => onDataChange('template_id', e.target.value)}
                            placeholder="e.g. welcome_msg"
                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                        />
                    </div>
                )}

                {(selectedNode.type === 'email' || selectedNode.data.label.toLowerCase().includes('email')) && (
                    <div className="form-group" style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Subject</label>
                        <input
                            type="text"
                            value={nodeData.subject || ''}
                            onChange={(e) => onDataChange('subject', e.target.value)}
                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                        />
                    </div>
                )}

                {(selectedNode.type === 'delay' || selectedNode.data.label.toLowerCase().includes('delay')) && (
                    <div className="form-group" style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Duration (minutes)</label>
                        <input
                            type="number"
                            value={nodeData.duration || ''}
                            onChange={(e) => onDataChange('duration', e.target.value)}
                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                        />
                    </div>
                )}

                {(selectedNode.type === 'condition' || selectedNode.data.label.toLowerCase().includes('condition')) && (
                    <>
                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Condition Type</label>
                            <select
                                value={nodeData.condition_type || 'user_tag'}
                                onChange={(e) => onDataChange('condition_type', e.target.value)}
                                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                            >
                                <option value="user_tag">User Tag</option>
                                <option value="custom_var">Custom Variable</option>
                            </select>
                        </div>

                        {nodeData.condition_type === 'user_tag' ? (
                            <div className="form-group" style={{ marginBottom: '15px' }}>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Tag Name</label>
                                <input
                                    type="text"
                                    value={nodeData.tag_name || ''}
                                    onChange={(e) => onDataChange('tag_name', e.target.value)}
                                    placeholder="e.g. VIP"
                                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                                />
                            </div>
                        ) : (
                            <>
                                <div className="form-group" style={{ marginBottom: '15px' }}>
                                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Variable Name</label>
                                    <input
                                        type="text"
                                        value={nodeData.variable || ''}
                                        onChange={(e) => onDataChange('variable', e.target.value)}
                                        placeholder="e.g. plan_type"
                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                                    />
                                </div>
                                <div className="form-group" style={{ marginBottom: '15px' }}>
                                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Expected Value</label>
                                    <input
                                        type="text"
                                        value={nodeData.value || ''}
                                        onChange={(e) => onDataChange('value', e.target.value)}
                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                                    />
                                </div>
                            </>
                        )}
                        <div style={{ fontSize: '12px', color: '#666', marginTop: '10px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '4px', borderLeft: '3px solid #007bff' }}>
                            <strong>Tip:</strong> Ensure you have edges labeled "true" and "false" coming out of this node.
                        </div>
                    </>
                )}

            </div>
        </aside>
    );
};

export default PropertyPanel;
